import { _ } from '../utils.js'
export default class CheckboxToggle {
    constructor(el) {
        this.el = el
        this.triggerCheck = el.querySelector(_('check-all').str())
        this.triggerUncheck = el.querySelector(_('uncheck-all').str())
        this.triggerDisable = el.querySelector(_('disable-all').str())
        this.triggerCheck?.addEventListener(
            'click',
            this.toggleCheckboxes(true),
        )
        this.triggerUncheck?.addEventListener(
            'click',
            this.toggleCheckboxes(false),
        )

        if (this.triggerDisable) {
            this.disableCheckboxes()
            this.triggerDisable.addEventListener(
                'click',
                this.disableCheckboxes,
            )
        }
    }

    /**
     * @param  {Boolean} check - true to add checks / false to remove
     */

    toggleCheckboxes = (check) => {
        return () => {
            this.triggerUncheck.classList.toggle('u-hidden')
            this.triggerCheck.classList.toggle('u-hidden')

            _('checkbox', 'element')
                .nodesFrom(this.el)
                .map((el) => {
                    el.checked = check
                })
        }
    }

    disableCheckboxes = () => {
        _('checkbox', 'element')
            .nodesFrom(this.el)
            .map((el) => {
                el.disabled = this.triggerDisable.checked === true
            })
    }
}
